import Header from '../components/Header';

function Page404() {
  return (
    <div className="bg-sky-800 text-white min-h-screen overflow-hidden flex flex-col">
      <Header/>
      <main className="flex-1 flex flex-col justify-center items-center">
        <span className="text-9xl">404</span>
        <div className="mt-4 w-full max-w-xl px-4 text-center">
          <p className="text-base">Oups, cette page est introuvable.</p>
          <p className="text-base mt-2">
            Retournez à l'accueil pour découvrir nos services en ingénierie et conseil en cognitique.
          </p>
        </div>
      </main>
    </div>
  );
}

export default Page404;